import React from "react";
import { DataValue } from "../CommonComponents/commonStyles";

export function renderAmountGrid(data) {
  return data !== null ? (
    <DataValue className="mt0">
      {"$" +
        Number(data).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}
    </DataValue>
  ) : (
    <DataValue> &mdash; </DataValue>
  );
}
